var exports = {
  "kL": "CompactVoiceCallView.module__container___OThDdl",
  "gw": "CompactVoiceCallView.module__containerNoHeader___OThDdl",
  "lf": "CompactVoiceCallView.module__containerReserveHeaderChrome___OThDdl",
  "L7": "CompactVoiceCallView.module__containerNoControlBar___OThDdl",
  "ap": "CompactVoiceCallView.module__containerFillHeight___OThDdl",
  "tZ": "CompactVoiceCallView.module__contentArea___OThDdl",
  "$7": "CompactVoiceCallView.module__contentAreaAudioOnly___OThDdl",
  "OZ": "CompactVoiceCallView.module__audioAvatarLayout___OThDdl",
  "a3": "CompactVoiceCallView.module__audioAvatarLayoutInner___OThDdl",
  "d6": "CompactVoiceCallView.module__audioAvatarLayoutFullBleed___OThDdl",
  "nd": "CompactVoiceCallView.module__audioAvatarLayoutInnerFullBleed___OThDdl",
  "Gq": "CompactVoiceCallView.module__audioAvatarList___OThDdl",
  "D9": "CompactVoiceCallView.module__layoutHost___OThDdl",
  "pl": "CompactVoiceCallView.module__layoutHostFullHeight___OThDdl",
  "DO": "CompactVoiceCallView.module__layoutHostFullHeightGrid___OThDdl",
  "vR": "CompactVoiceCallView.module__layoutHostFullHeightFocus___OThDdl",
  "_t": "CompactVoiceCallView.module__controlBarSection___OThDdl",
  "Vw": "CompactVoiceCallView.module__controlBarInner___OThDdl",
  "AD": "CompactVoiceCallView.module__fullscreenButtonWrap___OThDdl",
  "I": "CompactVoiceCallView.module__heightToggleButtonWrap___OThDdl",
  "Ip": "CompactVoiceCallView.module__heightToggleButtonShell___OThDdl",
  "x8": "CompactVoiceCallView.module__heightTogglePill___OThDdl",
  "_A": "CompactVoiceCallView.module__heightTogglePillIcon___OThDdl",
  "oP": "CompactVoiceCallView.module__heightToggleUnreadBadge___OThDdl",
  "Di": "CompactVoiceCallView.module__resizeHandle___OThDdl",
  "YC": "CompactVoiceCallView.module__resizePill___OThDdl",
  "$I": "CompactVoiceCallView.module__containerResizing___OThDdl",
};

module.exports = exports;
